import { RootState } from "../store";

export const selectInitialized = (state: RootState) => state.app.initialized;

export const selectBrandId = (state: RootState) => state.app.brandId;

export const selectBrandCityId = (state: RootState) => state.app.brandCityId;

export const selectPointId = (state: RootState) => state.app.pointId;
